import React, { useState } from 'react';
import styles from './Navigation.module.css';

const Navigation = ({ onNavigate, activeTab = 'home' }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);

  const navigationItems = [
    { id: 'home', label: 'Home' },
    { id: 'rooms', label: 'Rooms' },
    { id: 'menu', label: 'Restaurant' },
    { id: 'welcoming-bar', label: 'Bar' },
    { id: 'contact', label: 'Contact' }
  ];

  const handleNavClick = (tabId) => {
    if (onNavigate) {
      onNavigate(tabId);
    }
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const handleNavMouseEnter = (itemId) => {
    setHoveredItem(itemId);
  };

  const handleNavMouseLeave = () => {
    setHoveredItem(null);
  };


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={styles.navigation}>
      <div className={styles['nav-container']}>
        <button className={styles.logo} onClick={() => handleNavClick('home')}>
          <span className={styles['logo-qh']}>Q</span>
          <div className={styles['logo-text']}>
            <span className={styles['logo-main']}>QUEENS HOTEL</span>
            <span className={styles['logo-sub']}>HARLECH</span>
          </div>
        </button>
        
        <button 
          className={styles['mobile-toggle']}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`${styles['nav-links']} ${isMobileMenuOpen ? styles['mobile-open'] : ''}`}>
          {navigationItems.map(item => (
            <li 
              key={item.id}
              onMouseEnter={() => handleNavMouseEnter(item.id)}
              onMouseLeave={handleNavMouseLeave}
            >
              <button 
                className={`${styles['nav-link']} ${
                  hoveredItem 
                    ? (hoveredItem === item.id ? styles.active : '')
                    : (activeTab === item.id ? styles.active : '')
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.id);
                }}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;